import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    standalone: true,
    name: 'formatDate',
    
})
export class FormatDatePipe implements PipeTransform {
  transform(value: string, format: string): string {
    const dateObject = dayjs(value);
    if (!dateObject.isValid()) {
      return '--';
    }
    return dayjs(value).format(format);
  }
}
